export default "__VITE_ASSET__DXw1tcj3__"